export const bytesToMegabytes = (bytes: number): number => {
  const k = 1024;
  return bytes / k / k;
};
